import './styles.scss';

import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { flowSteps, recordFlowProgress } from '../utils/recordFlowProgress';

import LoginCard from '../ui/LoginCard';
import LoginLayout from '../ui/Layout/LoginLayout';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { SignUp } from 'aws-amplify-react';
import withContentfulTag from '../utils/withContentfulTag';

/**
 * Extending amplify boilerplate SignUp screen.
 */
class LoopSignUp extends SignUp {
  /**
   * Class constructor
   * @param {Object} props The screen's properties
   */
  constructor(props) {
    super(props);
    this._validAuthStates = ['signUp'];

    this.state = {
      username: '',
    };

    this.signUpFields = [
      {
        label: 'First name',
        key: 'given_name',
        required: true,
        displayOrder: 1,
        type: 'string',
        placeholder: '',
      },
      {
        label: 'Last name',
        key: 'family_name',
        required: true,
        displayOrder: 2,
        type: 'string',
        placeholder: '',
      },
      {
        label: 'Email',
        key: 'username',
        required: true,
        displayOrder: 3,
        type: 'email',
        placeholder: '',
      },
      {
        label: 'Password',
        key: 'password',
        required: true,
        displayOrder: 4,
        type: 'password',
        placeholder: '',
      },
    ];
  }

  /**
   * Component did update handler
   * @param {Object} prevProps The previous props
   * @param {Object} prevState The previous state
   * @param {Object} snapshot
   */
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.authState === 'signUp' && !this.tracked) {
      this.tracked = true;
    } else if (this.props.authState !== 'signUp') {
      this.tracked = false;
    }
  }

  /**
   * Show loop forgot password screen
   * @param {Object} theme The theme object
   * @return {JSX.Element}
   */
  showComponent(theme) {
    const { loading, fetched, contentful } = this.props;
    const { requestPending } = this.state;
    return (
      !loading &&
      fetched && (
        <LoginLayout>
          <LoginCard>
            <Card.Title as="h1">{contentful.title}</Card.Title>
            <Card.Text>{contentful.subtitle}</Card.Text>
            <Card.Body className="p-0">
              <Container className="text-left">
                <Row>
                  <Col className="px-lg-3 px-md-2 px-1">
                    <Form.Group className="mb-md-3 mb-2">
                      <Form.Label htmlFor="given_name">First name</Form.Label>
                      <Form.Control
                        id="signup_given_name"
                        key="given_name"
                        name="given_name"
                        onBlur={() =>
                          recordFlowProgress(flowSteps.ENTER_FIRST_NAME, false)
                        }
                        onChange={this.handleInputChange}
                        type="text"
                        placeholder="First name"
                      />
                    </Form.Group>
                  </Col>
                  <Col className="px-lg-3 px-md-2 px-1">
                    <Form.Group className="mb-md-3 mb-2">
                      <Form.Label htmlFor="family_name">Last name</Form.Label>
                      <Form.Control
                        id="signup_family_name"
                        key="family_name"
                        name="family_name"
                        onBlur={() =>
                          recordFlowProgress(flowSteps.ENTER_LAST_NAME, false)
                        }
                        onChange={this.handleInputChange}
                        type="text"
                        placeholder="Last name"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col className="px-lg-3 px-md-2 px-1">
                    <Form.Group className="mb-md-3 mb-2">
                      <Form.Label htmlFor="username">Email address</Form.Label>
                      <Form.Control
                        id="signup_username"
                        key="username"
                        name="username"
                        onBlur={() =>
                          recordFlowProgress(flowSteps.ENTER_EMAIL, false)
                        }
                        onChange={e => {
                          e.target.value = e.target.value.toLowerCase().trim();
                          this.handleInputChange(e);
                        }}
                        type="email"
                        placeholder="Email address"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col className="px-lg-3 px-md-2 px-1">
                    <Form.Group className="mb-md-3 mb-2">
                      <Form.Label htmlFor="password">
                        Create a password
                      </Form.Label>
                      <Form.Control
                        id="signup_password"
                        key="password"
                        name="password"
                        onBlur={() =>
                          recordFlowProgress(flowSteps.CREATE_PASSWORD, false)
                        }
                        onChange={this.handleInputChange}
                        type="password"
                        placeholder="Create a password"
                      />
                    </Form.Group>
                    <div className="terms text-left color-light">
                      <p>
                        Must be at minimum 8 characters including upper and
                        lower case, number and symbol.
                      </p>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className="px-lg-3 px-md-2 p-1">
                    <div className="terms text-center mt-3">
                      <ReactMarkdown>{contentful.body}</ReactMarkdown>
                    </div>
                    <Button
                      variant="primary"
                      type="submit"
                      disabled={requestPending}
                      onClick={() => {
                        const username = this.inputs?.username || '';
                        this.inputs.username = username.toLowerCase().trim();
                        return this.signUp();
                      }}
                      className="mb-2 w-100">
                      {contentful.primaryButtonText}
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col className="px-lg-3 px-md-2 px-1">
                    <Form.Group className="mb-0 mt-1">
                      <hr className="mt-3 mb-4" />
                      <p className="text-center mb-0 d-flex justify-content-between">
                        <span className="signup-text">
                          {contentful.bodyEnd}
                        </span>
                        <Button
                          type="button"
                          variant="outline-primary"
                          onClick={() => super.changeState('signIn')}
                          className="px-4">
                          {contentful.secondaryButtonText}
                        </Button>
                      </p>
                    </Form.Group>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </LoginCard>
        </LoginLayout>
      )
    );
  }
}
export default withContentfulTag(LoopSignUp, 'web_app_signup_page');
